import React from 'react';

import PropTypes from 'prop-types';

import Modal from '@src/components/common/Modal';

import Form from '../SearchForm';

import './SearchModal.scss';

const SearchModal = ({ onClose, onKeyDown, onSubmit }) => (
    <Modal
        contentClassName="search-modal"
        onClose={onClose}
        onKeyDown={onKeyDown}
    >
        <Form onSubmit={onSubmit} />
    </Modal>
);

SearchModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default React.memo(SearchModal);
